import React from 'react';
import { ClassAssembly11C2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly11C2026/>;
  };
  
  export default ClassAssemblyPage;